import { render, staticRenderFns } from "./e-button-main.vue?vue&type=template&id=967ea6e0&scoped=true&lang=pug"
import script from "./e-button-main.vue?vue&type=script&lang=js"
export * from "./e-button-main.vue?vue&type=script&lang=js"
import style0 from "./e-button-main.vue?vue&type=style&index=0&id=967ea6e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "967ea6e0",
  null
  
)

export default component.exports